import { render, staticRenderFns } from "./CompanyList.vue?vue&type=template&id=13a98182&scoped=true"
import script from "./CompanyList.vue?vue&type=script&lang=js"
export * from "./CompanyList.vue?vue&type=script&lang=js"
import style0 from "./CompanyList.vue?vue&type=style&index=0&id=13a98182&prod&lang=scss&scoped=true"
import style1 from "./CompanyList.vue?vue&type=style&index=1&id=13a98182&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a98182",
  null
  
)

export default component.exports